module.exports = {}


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/packages/yofoui/base/components/utils/img-url/icon.json
// module id = 842
// module chunks = 418